// Clears only Auth0 + your own auth artifacts
export function clearAuthArtifacts(clientId: string) {
    try {
        // Auth0 SPA SDK keys in localStorage
        const prefixes = ['@@auth0spajs@@', '@@auth0spajs@::', '@@auth0spajs'];
        Object.keys(localStorage).forEach((k) => {
            if (prefixes.some((p) => k.startsWith(p)) || k.includes(clientId)) {
                localStorage.removeItem(k);
            }
        });
    } catch { /* ignore */ }

    try {
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('currentProjectId');
        localStorage.removeItem('invite_token');
    } catch { /* ignore */ }
}

// Optional: clear first-party cookies your app may set (can’t clear Auth0 domain cookies)
export function clearAppCookies() {
    document.cookie.split(';').forEach((c) => {
        const eq = c.indexOf('=');
        const name = (eq > -1 ? c.substring(0, eq) : c).trim();
        if (!name) return;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
}